import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RaRoutingModule } from "./ra-routing.module";
import { MaterialModule } from "../material/material.module";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from "@angular/material/form-field";
import { FailedMessageModal, FullAnalysisDialogComponent, NewAnalysisDialogComponent, RaResultsComponent } from "./ra-results/ra-results.component";
import { RaInputPromptComponent } from "./ra-input-prompt/ra-input-prompt.component";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { MatSelectModule } from "@angular/material/select";
import { RaDashbaordComponent } from "./ra-dashbaord.component";
import { GptSettingsDialogComponent } from "./gpt-dialogs/gpt-settings-dialog.component";
import { AiResultsTableComponent } from "./ra-results/ai-results-table/ai-results-table.component";
import { AiProjectBannerComponent } from "./ra-results/ai-project-banner/ai-project-banner.component";
import { RaFooterComponent } from "./ra-footer/ra-footer.component";

@NgModule({
  declarations: [
    AiProjectBannerComponent,
    RaInputPromptComponent,
    RaResultsComponent,
    RaDashbaordComponent,
    GptSettingsDialogComponent,
    AiResultsTableComponent,
    FullAnalysisDialogComponent,
    NewAnalysisDialogComponent,
    FailedMessageModal,
    RaFooterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RaRoutingModule,
    MaterialModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    RouterModule,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } }
  ],
})
export class RaModule {}
